import {Model} from "./";
import {Api} from "../api";

class ProductNotificationSubscriptionModel extends Model {

    constructor() {
        super(new Api("/product-notification-subscription"));
    }

    findOne(data, thenFunction, errorFunction) {
        this.q.setDopUrl('/find-one');
        this.q.read(data, thenFunction, errorFunction);
    }

    subscribe(data, thenFunction, errorFunction) {
        this.q.setDopUrl('/subscribe');
        this.q.create(data, thenFunction, errorFunction);
    }

    unsubscribe(data, thenFunction, errorFunction) {
        this.q.setDopUrl('/unsubscribe');
        this.q.create(data, thenFunction, errorFunction);
    }
}

export default new ProductNotificationSubscriptionModel();

